'use strict';

module.exports = require('./Checkbox');


//////////////////
// WEBPACK FOOTER
// ./~/rc-checkbox/lib/index.js
// module id = 538
// module chunks = 0